import React from 'react';
import useAgeVerification from './useAgeVerification'; // Import the custom hook

const AgeVerification = () => {
  const { isOver18, verifyOver18, redirectUnder18 } = useAgeVerification();

  const overlayStyles = {
    position: 'fixed',
    inset: 0,
    display: isOver18 ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999999,
    backdropFilter: 'blur(10px)',
  };

  const popupStyles = {
    background: '#dbdfeb',
    border: '1px solid rgba(0, 0, 0, 0.14)',
    padding: '2.5em 3em',
    textAlign: 'center',
    borderRadius: '8px',
    maxWidth: '90%',
  };

  return !isOver18 ? (
    <div className="age-verification-overlay" style={overlayStyles}>
      <div className="age-verification-popup" style={popupStyles}>
        <p style={{ margin: '0 0 2em 0', color: '#141414' }}>
          This website contains explicit material. Please verify your age to enter.
        </p>
        <div
          className="buttons"
          style={{
            display: 'flex',
            gap: '1em',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <button type="button" onClick={redirectUnder18}>
            I am under 18
          </button>
          <button type="button" onClick={verifyOver18}>
            I am over 18
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default AgeVerification;
